import Img_A1 from '../../assets/Acheive1.jpg'
import Img_A2 from '../../assets/Acheive2.jpg'
import Img_A3 from '../../assets/Acheive3.jpg'
import Img_A4 from '../../assets/Acheive4.jpg'
import Img_A5 from '../../assets/Acheive5.jpg'
import Img_A6 from '../../assets/Acheive6.jpg'
import Img_A7 from '../../assets/Acheive7.jpg'
import Img_A8 from '../../assets/Acheive8.jpeg'
import Img_A9 from '../../assets/Acheive9.jpeg'
import Img_A10 from '../../assets/Acheive10.jpeg'
import Img_A11 from '../../assets/Acheive11.jpeg'
import Img_A12 from '../../assets/Acheive12.jpeg'
import Img_A13 from '../../assets/Acheive13.jpeg'
import Img_A14 from '../../assets/Acheive14.jpg'


const AcheivementData = [
    {
        id:1,
        image:Img_A1
    },
    {
        id:2,
        image:Img_A2
    },
    {
        id:3,
        image:Img_A3
    },
    {
        id:4,
        image:Img_A4
    },
    {
        id:5,
        image:Img_A5
    },
    {
        id:6,
        image:Img_A6
    },
    {
        id:7,
        image:Img_A7
    },
    {
        id:8,
        image:Img_A8
    },
    {
        id:9,
        image:Img_A9
    },
    {
        id:10,
        image:Img_A10
    },
    {
        id:11,
        image:Img_A11
    },
    {
        id:12,
        image:Img_A12
    },
    {
        id:13,
        image:Img_A13
    },
    {
        id:14,
        image:Img_A14
    },
]

export default AcheivementData;